import {Endpoint} from '@eryxcoop/appyx-comm';

export default class RequestJudicialStageAdvanceEndpoint extends Endpoint {

    adaptValues({businessName, reason}) {
        return {
            business_name: businessName,
            reason: reason,
        }
    }
}
